// PROD
// const baseUrl = "https://dms.nablasol.net";

// DEV
const baseUrl = "https://ctaxdmsnewdev.nablasol.net";

export default baseUrl;
